import { AppRouteProps } from '@harea/component'
import React from 'react'

const Dashboard = React.lazy(() => import('./container/DashboardContainer'))

export const DashboardRoutes: Array<AppRouteProps> = [
    { 
        path: 'dashboard', 
        element: <Dashboard />,
    }
]
